var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditFines',{directives:[{name:"show",rawName:"v-show",value:(_vm.fines),expression:"fines"}],attrs:{"accident":_vm.fines}})}
var staticRenderFns = []

export { render, staticRenderFns }